/**
 * @file: 初始化config
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';
import Config from '../config/index';

export default function updateConfig(shelfData: JsonData): void {
    let urlParams: FreeObjMap = Utils.queryUrl(window.location.href);
    let venderId: any = Config.getGlobalConfig('CURRENT_VERNDER_ID');
    let paperId: any = Config.getGlobalConfig('displayId');
    let auth: any = Config.getGlobalConfig('stageAuth');
    let renderFace: number = 0;

    if (/face=4/.test(window.location.href)) {
        renderFace = 4;
    }

    // 是否跨卧柜
    Config.set({
        moduleName: 'freezer',
        key: 'cabinetTransLayout',
        value: !!shelfData.cubeData.crossShelf
    });

    // 图纸渲染方位
    Config.set({
        moduleName: 'base',
        key: 'renderFace',
        value: renderFace
    });

    // 图纸id
    Config.set({
        moduleName: 'base',
        key: 'paperId',
        value: Utils.toNumberForce(paperId)
    });

    // 商家id
    Config.set({
        moduleName: 'base',
        key: 'venderId',
        value: Utils.toNumber(venderId)
    });

    // 权限
    Config.set({
        moduleName: 'base',
        key: 'auth',
        value: Utils.toNumber(auth)
    });
}
